import { FC, HTMLAttributes } from 'react';
import clx from 'classnames';
import { Avatar, Button } from 'src/Components';
import st from './UserInfo.module.scss';

interface IUserInfoProps extends HTMLAttributes<HTMLDivElement> {
	userName?: string;
	userOrg?: string;
	avatar?: string | null;
	gender?: 'female' | 'male';
	email?: string;
	isClear?: boolean;
	onClear?: () => void;
	notHovered?: boolean;
	/** Включает обрезку длинного текста */
	short?: boolean;
}

const UserInfo: FC<IUserInfoProps> = ({
	userName = '',
	notHovered = false,
	userOrg = '',
	avatar = '',
	gender,
	email = '',
	isClear = false,
	onClear,
	className,
	short = false,
	...otherProps
}) => {
	return (
		<div
			className={clx(st.userInfoBlock, className, {
				[st.notHovered]: notHovered,
				[st.short]: short,
			})}
			{...otherProps}
		>
			<Avatar
				avatarUrl={avatar}
				gender={gender}
				title="Аватар пользователя"
				size={36}
			/>

			<div className={st.textBlock}>
				<h6 className="body-large">{userName}</h6>
				<span className="body-small">{userOrg || email}</span>
			</div>

			{isClear && onClear && (
				<Button
					size="min"
					outline
					onClick={() => {
						return onClear();
					}}
				>
					<svg
						width="12"
						height="12"
						viewBox="0 0 12 12"
						fill="inherit"
					>
						<path
							d="M11.3957 1.81286C11.7295 1.47912 11.7295 0.938023 11.3957 0.604285C11.062 0.270548 10.5209 0.270548 10.1871 0.604286L6 4.79143L1.81286 0.604285C1.47912 0.270547 0.938023 0.270548 0.604286 0.604286C0.270548 0.938023 0.270548 1.47912 0.604286 1.81286L4.79143 6L0.604285 10.1871C0.270547 10.5209 0.270548 11.062 0.604285 11.3957C0.938023 11.7295 1.47912 11.7295 1.81286 11.3957L6 7.20857L10.1871 11.3957C10.5209 11.7295 11.062 11.7295 11.3957 11.3957C11.7295 11.062 11.7295 10.5209 11.3957 10.1871L7.20857 6L11.3957 1.81286Z"
							fill="inherit"
						/>
					</svg>
				</Button>
			)}
		</div>
	);
};

export default UserInfo;
